import { SecureStorageKeys } from "constants/secureStorage";
import * as CelleraSDK from "libs/cellera-sdk";
import { apiMiddleWare } from "utils/apiInterceptor";
import { secureStorage } from "utils/secureStorage";

const token = secureStorage.get(SecureStorageKeys.CUSTOM_TOKEN);

const celleraConfig = new CelleraSDK.Configuration({
  basePath: process.env.REACT_APP_CELLERA_API_BASE_URL,
  headers: {
    Authorization: `Bearer ${token}`,
  },
  middleware: [apiMiddleWare],
});

export const authenticationApi = new CelleraSDK.AuthenticationApi(
  celleraConfig
);

export const practiceProfileApi = new CelleraSDK.PracticeApi(celleraConfig);

export const patientFunctionalLifestyleApi =
  new CelleraSDK.PatientFunctionalLifestyleApi(celleraConfig);

export const patientGoalsOfTreatmentApi =
  new CelleraSDK.PatientGoalsOfTreatmentApi(celleraConfig);
export const patientsApi = new CelleraSDK.PatientApi(celleraConfig);

export const appointmentApi = new CelleraSDK.ProviderAppointmentsApi(
  celleraConfig
);

export const appointmentTypeApi = new CelleraSDK.AppointmentTypeApi(
  celleraConfig
);

export const patientNutritionApi = new CelleraSDK.PatientNutritionApi(
  celleraConfig
);

export const patientsGeneralInformationApi =
  new CelleraSDK.PatientsGeneralInformationApi(celleraConfig);

export const patientsSocialHistoryApi = new CelleraSDK.PatientSocialHistoryApi(
  celleraConfig
);

export const patientsFamilyHistoryApi = new CelleraSDK.PatientsFamilyHistoryApi(
  celleraConfig
);

export const patientPastMedicalHistoryApi = new CelleraSDK.PatientProfileApi(
  celleraConfig
);

export const patientsMedicationsApi = new CelleraSDK.PatientMedicationsApi(
  celleraConfig
);

export const patientPresentingConcernsApi =
  new CelleraSDK.PatientPresentingConcernsApi(celleraConfig);

export const patientAdditionalNotesApi =
  new CelleraSDK.PatientAdditionalNotesApi(celleraConfig);

export const patientFertilityReproductiveHealthApi =
  new CelleraSDK.PatientFertilityReproductiveHealthApi(celleraConfig);

export const activityApi = new CelleraSDK.ActivityApi(celleraConfig);

export const practiceUsersApi = new CelleraSDK.PracticeUsersApi(celleraConfig);

export const patientGeneticsApi = new CelleraSDK.PatientGeneticsReportsApi(
  celleraConfig
);

export const patientBiomarkersApi = new CelleraSDK.PatientBiomarkersApi(
  celleraConfig
);

export const practicePaymentApi = new CelleraSDK.PracticePaymentApi(
  celleraConfig
);

export const roleManagementApi = new CelleraSDK.RoleManagementApi(
  celleraConfig
);

export const treatmentPlanApi = new CelleraSDK.TreatmentPlanApi(celleraConfig);

export const practicePatientManagementApi =
  new CelleraSDK.PracticePatientManagementApi(celleraConfig);

export const prescriptionApi = new CelleraSDK.PrescriptionProviderApi(
  celleraConfig
);

export const supplementProviderApi = new CelleraSDK.SupplementProviderApi(
  celleraConfig
);

export const medicineProviderApi = new CelleraSDK.MedicineProviderApi(
  celleraConfig
);

export const medicationProviderApi = new CelleraSDK.MedicationProviderApi(
  celleraConfig
);

export const providerApi = new CelleraSDK.ProviderApi(celleraConfig);

export const chatApi = new CelleraSDK.ChatApi(celleraConfig);

export const practiceConnectApi = new CelleraSDK.PracticeConnectApi(
  celleraConfig
);

export const medicineApi = new CelleraSDK.MedicineApi(celleraConfig);

export const chatBotApi = new CelleraSDK.ChatbotApi(celleraConfig);

export const instructionApi = new CelleraSDK.InstructionApi(celleraConfig);

export const procedureApi = new CelleraSDK.ProcedureApi(celleraConfig);

export const geographyApi = new CelleraSDK.GeographyApi(celleraConfig);

export const faxesApi = new CelleraSDK.FaxesApi(celleraConfig);

export const faxesPatientApi = new CelleraSDK.FaxesPatientApi(celleraConfig);

export const googleCalendarApi = new CelleraSDK.ProviderGoogleCalendarApi(
  celleraConfig
);
